exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination {\n  margin-bottom: 0;\n}\ntable.dataTable tbody input[type=number] {\n  text-align: right;\n}\ntable.dataTable tbody tr.row-selected {\n  background-color: #E7EEFF !important;\n}\ntable.dataTable tbody .md-icon {\n  min-width: 15px;\n}\n.dataTables_scroll .header-table-wrapper table.dataTable {\n  margin-bottom: 0;\n}\n.md-icon {\n  min-width: 15px;\n}\ntable.table-sticky {\n  border: none !important;\n}\ntr.header-upper th {\n  border-bottom: 1px solid #c6c6c6;\n}", ""]);

// exports
